<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">ACKNOWLEDGEMENTS</p>
<p class="noindent">This book is dedicated to Shawn Snow. His passion for history in general and transit in specific enriches us all!</p>
<p class="indent">This book would not have been possible without the generosity of those who shared their memories, pictures, information and time, especially Kenton Forrest, the folks at the Colorado Railroad Museum, the Denver Tramway Heritage Society and the Regional Transportation District. Thank you!</p>
<p class="indent">Many pictures in this volume may be attributed to the following: the Denver Municipal Facts (DMF); the Denver Tramway Heritage Society (DTHS); the Colorado Railroad Museum (CRM); the Regional Transportation District (RTD); and the Englewood Public Library (EPL). Those not otherwise accredited are in the author’s personal collection.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?7c7516bb